import { EcommerceAPI } from "../Client";
import { appendProcessedFile } from "../../../utils/imageUploadProcessor";

export const uploadNotificationImageApi = async (payload) => {
  try {
    const formData = new FormData();
    await appendProcessedFile(formData, "file", payload.file);
    const response = await EcommerceAPI.post(
      `/notifications/image`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const markNotificationAsReadApi = async (notificationId) => {
  try {
    const response = await EcommerceAPI.put(
      `/internal/notification/${notificationId}/read`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getNotificationsApi = async (type) => {
  try {
    const response = await EcommerceAPI.get(`/internal/notification`, {
      params: {
        ...(type !== undefined && type !== null && type !== "" ? { type } : {}),
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createNotificationApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/internal/notification`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getNotificationTypesApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/internal/notification/types`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getNotificationCountApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/internal/notification/count`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteNotificationApi = async (notificationId) => {
  try {
    const response = await EcommerceAPI.delete(`/internal/notification/${notificationId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveFcmTokenAPI = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      "/internal/notification/fcm/token",
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};
